import styled from 'styled-components';
import colors from '../../styles/colors';

const Styles = styled.div`
    font: 14px/1.5 Roboto, sans-serif;

    height: 100vh !important;
    width: 100vw !important;
    overflow: hidden;

    background: white;

    .container {
        margin-right: 0px !important;
        max-width: 90%;
    }

    .btn-primary {
        background-color: ${colors.StuartBlue};
        border-color: ${colors.StuartBlue};
    }

    .title-row {
        margin-top: 32px;
        height: 92px;
        width: 100%;
    }

    .container-form {
        width: 100%;
    }

    .float-links {
        span {
            margin-right: 15px;
        }
    }

    h1 {
        font-size: 24px;
        margin-top: 16px !important;
        margin-bottom: 25px !important;
    }

    .wallpaper {
        width: 100%;
        height: 100vh;
        position: absolute;
        background-image: url(../../../../assets/images/courier1.jpg);
        background-position: center;
        background-size: 150vh;
    }

    p.horizontal-line {
        color: #8f96a0;
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #ced4da;
        line-height: 0.1em;
        margin: 1.5em 0 1.5em;
    }

    p.horizontal-line span {
        background: #fff;
        padding: 0 10px;
    }
`;

export default Styles;
